import { render } from "./index.vue?vue&type=template&id=354c637a"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/StagePipeline/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "354c637a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('354c637a', __exports__)) {
    api.reload('354c637a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=354c637a", () => {
    api.rerender('354c637a', render)
  })

}


export default __exports__